import {
  EyeOutlined,
  MoreOutlined
} from "@ant-design/icons";
import { Dropdown, Flex, Progress, Space, Tooltip } from "antd";
import TableAntd from "components/elements/Table/Table";
import TableAntdFix from "components/elements/Table/TableFixPage";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { useTranslation } from "react-i18next";

const EmployeeList = ({
  isLoading = false,
  pagination = {},
  employeeList = [],
  onView = () => { },
  onEdit = () => { },
  onChange = () => { },
  onDelete = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      title: (
        <div className="text-table">{t("employee.label.employee_id")}</div>
      ),
      dataIndex: "employeeNo",
      key: "employeeNo",
      sorter: true,
      render: (_, record) => {
        if (record?.employeeNo === null) {
          return "-";
        }
        return <span
          style={{
            color: "#42526D",
            backgroundColor: "#F5F6F7",
            borderRadius: "20px",
            width: "max-content",
            height: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            padding: "8px 16px"
          }}
        >
          {record?.employeeNo}
        </span>;
      },
      align: "center",
      width: '100px'
    },
    {
      title: <div className="text-table">{t("employee.label.name")}</div>,
      dataIndex: "name",
      key: "name",
      // sorter: true,
      width: '160px',
      render: (_, record) => {
        const isEn = i18n.language === "en";
        const fullName = isEn
          ? `${record?.nameEn} ${record?.surNameEn}`
          : `${record?.name} ${record?.surName}`;
        const nickname = isEn ? record?.nickNameEn : record?.nickName;

        return nickname ? `${fullName} (${nickname})` : fullName;
      },
    },
    {
      title: <div className="text-table">{t("employee.label.email")}</div>,
      dataIndex: "email",
      key: "email",
      // sorter: true,
      width: '220px',

    },
    {
      title: <div className="text-table">{t("employee.label.department")}</div>,
      dataIndex: "department",
      key: "department",
      // sorter: true,
      width: '120px',
      render: (_, record) => {
        if (i18n.language === "en") {
          return record?.department?.nameEn;
        }
        return record?.department?.name;
      },
    },
    {
      title: <div className="text-table">{t("employee.label.shift")}</div>,
      dataIndex: "shift",
      key: "shift",
      // sorter: true,
      width: '80px',
      render: (_, record) => {
        if (i18n.language === "en") {
          return record?.shift?.nameEn;
        }
        return record?.shift?.name;
      },
    },
    {
      title: <div className="text-table">{t("employee.label.type")}</div>,
      dataIndex: "employeeType",
      key: "employeeType",
      // sorter: true,
      width: '120px',
      render: (_, record) => {
        if (i18n.language === "en") {
          return record?.employeeType?.nameEn;
        }
        return record?.employeeType?.name;
      },
    },
    {
      title: <div className="text-table">{t("employee.label.status")}</div>,
      dataIndex: "employeeStatus",
      key: "employeeStatus",
      sorter: true,
      width: '120px',
      align: "center",
      render: (_, record) => {
        let language = i18n.language == 'en' ? "En" : ""
        return (
          record?.employeeStatus?.code ?
            <StatusTag
              value={record?.employeeStatus?.code}
              text={(record?.employeeStatus?.["name" + language])} /> : "-"

        )
      },
    },
    {
      title: <div className="text-table">{t("employee.label.fill_in")}</div>,
      dataIndex: "fillIn",
      key: "fillIn",
      width: '80px',
      align: "center",
      fixed: "right",
      render: (_, record) => {
        const countY = Object.values(record?.dataEntryList || {}).filter(value => value === "Y").length;
        const totalCount = Object.keys(record?.dataEntryList || {}).length;
        const percent = (countY / totalCount) * 100;
        const progressColor = percent === 100 ? "#2CADE7" : "#FF9800";

        const progressComponent = (
          <Progress
            type="circle"
            percent={percent}
            size={50}
            strokeWidth={9}
            trailColor="#FFF0D9"
            strokeColor={progressColor}
            format={percent => <span style={{ color: "#42526D" }}>{`${percent}%`}</span>}
          />
        );

        return percent == "100"
          ? (progressComponent)
          : (<Tooltip placement="bottom"
            title={
              <Flex vertical>
                <span>{t("employee.label.fillin_form")}</span>
                <ul>
                  {Object.entries(record?.dataEntryList || {})
                    .filter(([key, value]) => value === "N")
                    .map(([key]) => (
                      <li key={key}>&#8226; {t(`employee.label.${key}`)}</li>
                    ))}
                </ul>
              </Flex>}>
            {progressComponent}
          </Tooltip>)
      }
    },
    {
      title: <div className="text-table">{t("employee.label.fill_in_payroll")}</div>,
      dataIndex: "fillIn",
      key: "fillIn",
      width: '80px',
      align: "center",
      fixed: "right",
      render: (_, record) => {
        // console.log("record", record);

        const countY = Object.values(record?.payrollDataEntryList || {}).filter(value => value === "Y").length;
        const totalCount = Object.keys(record?.payrollDataEntryList || {}).length;
        const percent = Math.round((countY / totalCount) * 100);
        const progressColor = percent === 100 ? "#2CADE7" : "#FF9800";

        const progressComponent = (
          <Progress
            type="circle"
            percent={percent}
            size={50}
            strokeWidth={9}
            trailColor="#FFF0D9"
            strokeColor={progressColor}
            format={percent => <span style={{ color: "#42526D" }}>{`${percent}%`}</span>}
          />
        );

        return percent == "100"
          ? (progressComponent)
          : (<Tooltip placement="bottom"
            title={
              <Flex vertical>
                <span>{t("employee.label.fillin_form")}</span>
                <ul>
                  {Object.entries(record?.payrollDataEntryList || {})
                    .filter(([key, value]) => value === "N")
                    .map(([key]) => (
                      <li key={key}>&#8226; {t(`employee.label.${key}`)}</li>
                    ))}
                </ul>
              </Flex>}>
            <Progress
              type="circle"
              percent={percent}
              size={50}
              strokeWidth={9}
              trailColor="#FFF0D9"
              strokeColor={progressColor}
              format={percent => <span style={{ color: "#42526D" }}>{`${percent}%`}</span>}
            />
          </Tooltip>
          )
      }
    },
    {
      title: "",
      key: "action",
      width: 64,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  onClick: () => onView(record?.id),
                  label: `${t("action.view")}`,
                  icon: (
                    <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <TableAntdFix
      loading={isLoading}
      pagination={{
        ...pagination,
      }}
      dataSource={employeeList}
      columns={columns}
      onChange={onChange}
      // scroll={{ x: 'scroll' }}
      scroll={{ x: '1000px' }}
      tableLayout="fixed"
    />
  );
};

export default EmployeeList;
